import { render, staticRenderFns } from "./Cloudflare.vue?vue&type=template&id=397b0078&scoped=true"
import script from "./Cloudflare.vue?vue&type=script&lang=js"
export * from "./Cloudflare.vue?vue&type=script&lang=js"
import style0 from "./Cloudflare.vue?vue&type=style&index=0&id=397b0078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397b0078",
  null
  
)

export default component.exports